import { Select2 } from "@/ui2/molecules/Select";

import { getNoteTypeFilterOptions } from "../helpers/getNoteTypeFilterOptions";

type NoteTypeFilterProps = {
  onChange: (id: string) => void;
};

export function NoteTypeFilter({ onChange }: NoteTypeFilterProps) {
  const options = getNoteTypeFilterOptions();

  return <Select2 label="Note Type" onChange={onChange} options={options} placeholder="All" />;
}
